<template>
  <div>
    <div class="tableDiv">
      <div class="timeDiv">
        年月：
        <el-date-picker v-model="sbsj" type="month" value-format="yyyy-MM" placeholder="选择年月"></el-date-picker>
      </div>
      <div class="titleDiv"><span>{{ this.sbsj }} 各大队管理业绩考核指标基础项(30分)</span></div>
      <el-table :data="data" border highlight-current-row style="width: 96%">
        <el-table-column v-if="hideIdColumn" prop="id" label="ID"></el-table-column>
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
        <el-table-column prop="bmmc" label="大队" width="180" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.bmid" placeholder="请选择大队" @change="getGdXX(scope.row.bmid)">
              <el-option v-for="item in depts" :key="item.bmid" :label="item.bmmc" :value="item.bmid"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="jcsj" label="检查时间" width="260" align="center">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.jcsj" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="gd" label="岗点" width="220" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.gdid" filterable placeholder="请选择岗点">
              <el-option v-for="item in gdDatas" :key="item.gdid" :label="item.gdmc" :value="item.gdid"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="dy" label="队员" width="160" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.dy" placeholder="请输入队员姓名"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="kpnr" label="考评内容" width="260" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.kpnr" filterable placeholder="请选择" @change="knprChange(scope.row)">
              <el-option v-for="item in khnrDatas" :key="item.id" :label="item.kpnr" :value="item.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="kf" label="扣分" width="120" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.kf" placeholder="请输入扣分" :disabled="scope.row.kpnr !== '2e5f7b8c00ad44128f71730e80f4d02e'"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="filePath" label="附件" width="230" align="center">
          <template slot-scope="scope">
            <el-upload
              ref="upload"
              class="upload-demo"
              :action="uploadUrl"
              :before-upload="() => false"
              :on-remove="(file, fileList) => handleRemove(file, fileList, scope.$index)"
              :on-change="(file, fileList) => handleFileChange(file, fileList, scope.$index)"
              :file-list="scope.row.fileList"
              list-type="picture"
              :limit="1">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <img v-if="scope.row.imageurl" :src="scope.row.imageurl" class="avatar" />
            <el-button size="small" type="danger" @click="deleteButtonClicked(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-button type="primary" @click="addRow">新增一行</el-button>
        <el-button type="primary" round class="floating-button1" :disabled="handleSaveButton" @click="handleSave">保存</el-button>
        <el-button type="primary" round class="floating-button2" :disabled="releaseButton" @click="release">发布</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Compressor from 'compressorjs';

export default {
  data() {
    return {
      showButtons: false,
      data: [],
      rawData: [],
      sbsj: '',
      depts: [],
      bmid: '',
      bmmc: '',
      jcsj: '',
      imageurl: "",
      fileList: [],
      gdDatas: [],
      khnrDatas: [],
      hideIdColumn: false,
      handleSaveButton: false,
      releaseButton: false,
      isDfNull: false,
      kknrMap: new Map(),
      bmMap: new Map(),
      kpMap: new Map(),

      uploadUrl: '/upload/your-upload-url', // 替换成你的上传 URL
    };
  },
  created() {
    this.getDepts();
    this.getKhnrn();
  },
  methods: {
    getDepts() {
      this.$request({
        method: 'get',
        url: '/bjba/khxx/xjxx/findDdData'
      }).then((response) => {
        if (response.data.code === 200) {
          this.rawData = response.data.data;
          response.data.data.forEach(item => {
            this.bmMap.set(item.BMID,item.BMMC)
          })
          this.processData();
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    processData() {
      this.depts = this.rawData.map(item => {
        let newItem = {};
        for (let key in item) {
          if (item.hasOwnProperty(key)) {
            newItem[key.toLowerCase()] = item[key];
          }
        }
        return newItem;
      });
    },
    getGdXX(val) {
      console.log('选中的值为==', val)
      this.$request.get('/bjba/khxx/baqw/findGdxxByBmId', {
        params: { bmid: val }
      }).then(res => {
        this.gdDatas = res.data.data
      })
    },
    getKhnrn() {
      this.$request.get('/bjba/khxx/baqw/findKpnrData').then(res => {
        this.khnrDatas = res.data.data.map(item => {
          let newItem = {};
          for (let key in item) {
            if (item.hasOwnProperty(key)) {
              newItem[key.toLowerCase()] = item[key];
            }
          }
          return newItem;
        });
        this.khnrDatas.forEach(item => {
          this.kknrMap.set(item.id, item.kf); // 假设接口返回的数据有id和kf两个属性
        });
        this.khnrDatas.forEach(item => {
            this.kpMap.set(item.id,item.kpnr)
        })
      })
    },
    knprChange(row) {
      let df = this.kknrMap.get(row.kpnr);
      console.log("考评内容为==", df)
      if (row.kpnr === '2e5f7b8c00ad44128f71730e80f4d02e') {
        this.$set(row, 'kf', '');
      } else {
        this.$set(row, 'kf', df);
      }
    },

    release() {
      if (this.sbsj == '' || this.sbsj == undefined) {
        this.$message({
          message: '请选择时间',
          type: 'error',
          duration: 1500
        })
        return
      }
      this.$confirm('是否已保存？需先保存后发布，发布后不可更改')
        .then(_ => {
          this.$request.get('/bjba/khxx/baqw/release', {
            params: { bbsj: this.sbsj }
          }).then(res => {
            if (res.data.code === 200) {
              this.handleSaveButton = true
              this.releaseButton = true
              this.$message({
                message: res.data.message,
                type: 'success',
                duration: 1500
              })
              window.close();
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
                duration: 1500
              })
            }
          })
        })
        .catch(_ => { });

    },
    handleSave() {
      if (this.sbsj == '' || this.sbsj == undefined) {
        this.$message({
          message: '请选择时间',
          type: 'error',
          duration: 1500
        })
        return
      }
      this.$confirm('内容是否有遗漏？文件是否已上传服务器？')
        .then(_ => {

          // const filteredData = this.data.filter((row) => {
          //   return row.bmmc || row.jcsj || row.gd || row.dy || row.kpnr || row.kf;
          // });
          console.log('this.bmMap==',JSON.stringify(this.bmMap))
          
          const filteredData = this.data.map((item) => {
            return {
              ...item,
              bbjs: this.sbsj,
              bmmc: this.bmMap.get(item.bmid),
              kpmc: this.kpMap.get(item.kpnr)
            };
          });
          console.log('filteredData==',JSON.stringify(filteredData))
          this.$request({
            // method: 'post',
            // url: '/bjba/khxx/fzhs/mergeJcx',
            // data: { data: filteredData, sbsj: this.sbsj }
            url: '/bjba/khxx/baqw/saveBaqw',
            method: 'post',
            data: filteredData
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.message,
                type: 'success',
                duration: 1500
              });
              this.handleSaveButton = true;
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
                duration: 1500
              });
            }
          }).catch((err) => {
            console.log(err);
          });
        })
        .catch(_ => { });
    },
    addRow() {
      const lastRow = this.data[this.data.length - 1];
      if (lastRow && (lastRow.bmid === '' || lastRow.jcsj === '' || lastRow.gdid === '' || lastRow.dy === '' || lastRow.kpnr === '')) {
        this.$message({
          message: '上一行有空字段，请填写完整再添加新行',
          type: 'warning',
          duration: 1500
        });
        return;
      }
      this.isDfNull = false
      const newRow = {
        bmid: '',
        bmmc: '',
        jcsj: '',
        gdid: '',
        gd: '',
        dy: '',
        kpnr: '',
        kf: '',
        fileList: [], // Initialize fileList for each row
        imageurl: "", // Initialize imageurl for each row
      };
      this.data.push(newRow);
    },
    handleRemove(file, fileList, rowIndex) {
      this.data[rowIndex].fileList = fileList;
    },
    handleFileChange(file, fileList, rowIndex) {
      this.data[rowIndex].fileList = fileList;
      const formData = new FormData();
      formData.append('file', file.raw);
      new Compressor(file.raw, {
        quality: 0.6,
        convertSize: 5000000,
        success: (compressedFile) => {
          const reader = new FileReader();
          reader.readAsDataURL(compressedFile);
          reader.onload = (event) => {
            const base64File = event.target.result;
            console.log('compressedFile====',compressedFile)
            console.log('base64File====',base64File)
            // this.data[rowIndex].filePath = base64File
            this.data[rowIndex].imageurl = base64File
            console.log('fileList====',JSON.stringify(fileList))
            const newFileList = fileList.map((item) => {
              if (item.uid === file.uid) {
                return {
                  ...item,
                  url: base64File,
                  raw: compressedFile,
                };
              }
              return item;
            });
            console.log('newFileList====',newFileList)
            this.data[rowIndex].fileList = newFileList;
          };
        },
        error(err) {
          console.error(err.message);
        },
      });
    },
    deleteButtonClicked(row) {
      row.imageurl = null;
      row.fileList = [];
    }
  },
};
</script>

<style scoped>
.tableDiv {
  text-align: center;
}
.timeDiv {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.titleDiv {
  margin-bottom: 20px;
}
.avatar {
  width: 100px;
  height: 100px;
  margin-top: 10px;
}
.floating-button1 {
  position: fixed;
  bottom: 100px;
  right: 3%;
  padding: 10px 20px;
  background-color: #8bc516;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1000;
}

.floating-button1:hover {
  background-color: #0056b3;
}

.floating-button2 {
  position: fixed;
  bottom: 50px;
  right: 3%;
  padding: 10px 20px;
  background-color: #1482b5;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1000;
}

.floating-button2:hover {
  background-color: #0e90ad;
}
</style>
